<script>
import { mapActions } from "vuex";
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";
import Autocomplete from "@/components/_Shared/Autocomplete";
import Districts from "./Districts";

export default {
  props: {
    districts: {
      type: Array,
      required: true
    }
  },
  created() {
    this.list = this.districts;
  },
  components: {
    Modal,
    InputGroup,
    Autocomplete,
    Districts
  },
  data() {
    return {
      preloader: false,
      preloaderSearch: false,
      cities: [],
      city: false,
      list: []
    };
  },
  methods: {
    ...mapActions("cities", ["searchByName"]),
    ...mapActions("professionals", ["addDistricts"]),

    async search(query) {
      this.preloaderSearch = true;

      try {
        this.cities = await this.searchByName(query);
      } catch (e) {
        this.$toast.error(e);
      }

      this.preloaderSearch = false;
    },

    clear() {
      this.city = false;
    },

    select(city) {
      this.cities = [];
      this.city = city;

      city.districts.forEach(district => {
        if (!this.list.find(el => el.id === district.id))
          this.list.push(district);
      });
    },

    toggleFromList(district) {
      this.list.find(item => item.id === district.id)
        ? (this.list = this.list.filter(item => item.id != district.id))
        : this.list.push(district);
    },

    async submit() {
      this.preloader = true;

      try {
        let res = await this.addDistricts({
          professional_id: this.$route.params.id,
          districts: this.list
        });

        if (res) {
          this.$emit("refresh");
          this.$emit("close");
        }
      } catch (e) {
        this.$toast.error(e);
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <modal
    title="ÁREA DE ATENDIMENTO"
    subtitle="Busque os bairros pela cidade"
    size="md"
    @close="$emit('close')"
  >
    <template slot="body">
      <Autocomplete
        label="cidade"
        :selected="city"
        :results="cities"
        :preloader="preloaderSearch"
        :labels="['display_name']"
        @search="search"
        @select="select"
        @clear="clear"
      />

      <Districts
        v-if="city && city.districts.length"
        :districts="city.districts"
        :list="list"
        @toggleFromList="toggleFromList"
      />
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">
        fechar
      </button>
      <button
        class="btn bg-purple"
        :class="{ 'btn--loading': preloader }"
        @click="submit"
      >
        <span>cadastrar</span>
      </button>
    </template>
  </modal>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Districts/New/Index.vue